import Vue from 'vue'
import Utils from '@/utils'

Vue.filter('noDataAvailable', function (value) {
  if (value === null || value === undefined) {
    return 'Data null.'
  }
  return value
})

Vue.filter('noDataAvailableShort', function (value) {
  if (value === null || value === undefined) {
    return '/'
  }
  return value
})

Vue.filter('nullToFalse', function (value) {
  if (value == null) {
    return false
  }
  return value
})

Vue.filter('formatBool', function (value) {
  if (value === 1 || value === '1' || value === true) {
    return 'Yes'
  } else if (value === 0 || value === '0' || value === false) {
    return 'No'
  }
  return value
})

Vue.filter('formatDate', function (value) {
  if (value) {
    const parsed = Utils.parseDate(value)
    return parsed.format('YYYY-MM-DD')
  }
  return value
})

Vue.filter('formatHeight', function (value) {
  if (!value) {
    return value
  }
  return value + ' m'
})

Vue.filter('formatCoordinates', function (value) {
  if (!value) {
    return value
  }
  return parseFloat(value).toFixed(6)
})

Vue.filter('formatHeight', function (value) {
  if (!value) {
    return value
  }
  return parseFloat(value).toFixed(1) + 'm'
})
